import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import { connect } from 'react-redux';
import DateTime from '_class/DateTime';
import { Block, Flex, translate } from '@haldor/ui';
import { Collapsible } from 'UI';
import PostContent from 'components/Presentation/PostContent';
import Comments from './Partials/Comments';
import './Adjustment.scss';
var StudentAdjustment = /*#__PURE__*/function (_Component) {
  function StudentAdjustment() {
    var _this;
    _classCallCheck(this, StudentAdjustment);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, StudentAdjustment, [].concat(args));
    /* Helper methods */
    _defineProperty(_this, "getStatus", function () {
      if (_this.props.adjustment.status == 'ACTIVE') {
        return _this.props.translate('Active');
      }
      if (_this.props.adjustment.status == 'COMPLETED') {
        return _this.props.translate('Completed');
      }
    });
    return _this;
  }
  _inherits(StudentAdjustment, _Component);
  return _createClass(StudentAdjustment, [{
    key: "render",
    value: /* Render methods - JREND */
    function render() {
      var _adjustment$createdBy, _adjustment$createdBy2;
      var _this$props = this.props,
        adjustment = _this$props.adjustment,
        translate = _this$props.translate;
      var collapseTrigger = /*#__PURE__*/React.createElement("strong", {
        className: "trigger",
        style: {
          cursor: 'pointer'
        }
      }, /*#__PURE__*/React.createElement("span", {
        style: {
          whiteSpace: 'nowrap'
        }
      }, this.props.translate('Subjects'), " ", adjustment.subjects.length));
      return /*#__PURE__*/React.createElement("div", {
        className: "adjustment"
      }, /*#__PURE__*/React.createElement(Block, null, /*#__PURE__*/React.createElement("span", {
        className: "title"
      }, adjustment.additionalAdjustment.subTitle != null ? adjustment.additionalAdjustment.title + ' ' + adjustment.additionalAdjustment.subTitle : adjustment.additionalAdjustment.title), /*#__PURE__*/React.createElement(Flex, null, /*#__PURE__*/React.createElement("div", {
        style: {
          flex: 1
        }
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(PostContent, null, adjustment.description), /*#__PURE__*/React.createElement("div", {
        className: "createdBy color--meta"
      }, "".concat(((_adjustment$createdBy = adjustment.createdBy) === null || _adjustment$createdBy === void 0 ? void 0 : _adjustment$createdBy.firstName) || '', " ").concat(((_adjustment$createdBy2 = adjustment.createdBy) === null || _adjustment$createdBy2 === void 0 ? void 0 : _adjustment$createdBy2.lastName) || ''), ' • ' + new DateTime(adjustment.created).getTimeStampHours())), /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '1rem'
        }
      }, /*#__PURE__*/React.createElement(Comments, {
        adjustment: adjustment
      }))), /*#__PURE__*/React.createElement("div", {
        className: "side-info"
      }, adjustment.status == 'ACTIVE' ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("strong", null, translate('Start time')), /*#__PURE__*/React.createElement("br", null), new DateTime(adjustment.startDate).getLongDate()) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("strong", null, translate('Time period')), /*#__PURE__*/React.createElement("br", null), new DateTime(adjustment.startDate).getLongDate(), ' - ' + new DateTime(adjustment.endDate).getLongDate()), /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '1rem'
        }
      }, /*#__PURE__*/React.createElement("strong", null, translate('Status')), /*#__PURE__*/React.createElement("br", null), this.getStatus()), /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '1rem'
        }
      }, /*#__PURE__*/React.createElement(Collapsible, {
        trigger: collapseTrigger
      }, adjustment.subjects != null ? adjustment.subjects.map(function (subject) {
        return /*#__PURE__*/React.createElement("div", {
          key: subject.id
        }, subject.title);
      }) : null))))));
    }
  }]);
}(Component);
function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations)
  };
}
export default connect(mapStateToProps)(StudentAdjustment);